<template>
  <a
    @click="handleClick"
    :class="['share-btn', isRightBtn ? 'rightBtn' : '', isHonorRoll ? 'is-honor-roll' : '']"
    :style="buttonStyle"
  >
    <i class="shart-icon"></i>
    {{ title }}
  </a>
</template>

<script>
export default {
  name: "shareBtn",
  data() {
    return {}
  },
  props: {
    background: {
      type: String,
      default: "red",
    },

    title: {
      type: String,
      default: "查看海报",
    },
    isRightBtn: {
      type: Boolean,
      default: false,
    },
    isHonorRoll: {
      type: Number,
      default: 0,
    },  
    btnColor: {
      type: String,
      default: "",
    },
  },
  computed: {
    buttonStyle() {
      // 当btnColor有值且不为空时，使用动态颜色
      if (this.btnColor && this.btnColor.trim() !== '') {
        return {
          background: this.btnColor,
          borderColor: this.btnColor
        };
      }
      // 如果没有自定义颜色，返回空对象，使用CSS默认样式
      return {};
    }
  },
  methods: {
    handleClick() {
      this.$emit("shareClick");
    },
  },
};
</script>

<style lang="less">
.share-btn {
  width: 312px;
  height: 64px;
  margin: 0 auto;
  background: #656EE3;
  border-radius: 32px;
  border: 2px solid #656EE3;
  display: flex;
  align-items: center;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  justify-content: center;
  .shart-icon {
    width: 32px;
    height: 32px;
    margin-right: 12px;
    background: url("../../../../src/assets/images/winterGame/share.png")
      no-repeat;
    background-size: 100%;
  }
  &.is-honor-roll {
    padding-left: 22px;
  }
}
.rightBtn {
  width: 248px;
  border-radius: 32px 0 0 32px;
  justify-content: flex-start;
  padding-left: 40px;
}
</style>
